import api from "../..";
import type {
  GoldenChallenge,
  PatchGoldenChallengeChainParams,
  PatchGoldenChallengeParams,
} from "./types";
import type { ApiResponse } from "../../types";

export const patchGoldenChallenge = async ({ id, body }: PatchGoldenChallengeParams): Promise<boolean> => {

  return await api.patch<ApiResponse<GoldenChallenge>>(`/admin/golden-challenges/${id}/`, body)
  .then(() => true)
  .catch(() => false);
};

export const patchGoldenChallengeChain = async ({ id, body }: PatchGoldenChallengeChainParams): Promise<boolean> => {

  return await api.patch<ApiResponse<unknown>>(`/admin/challenges/chains/${id}/`, body)
  .then(() => true)
  .catch(() => false);
};
